import React from "react";
import { useTranslation } from "react-i18next";

const BenefitGroupChangedLocation = ({ notification }) => {
  const { t } = useTranslation();

  const benefitGroupName = notification?.payload?.benefit_group_name || "";

  return (
    <>
      <h4 className="notification-title">
        {t("notification_benefit_group_changed_location_title", {
          benefitGroupName
        })}
      </h4>
      <p className="notification-subtitle">
        {t("notification_benefit_group_changed_location_subtitle", {
          benefitGroupName
        })}
      </p>
      <p className="subtitle-description">
        {t("notification_benefit_group_changed_location_description",{
          benefitGroupName
        })}
      </p>
    </>
  );
};

export default BenefitGroupChangedLocation;
